import * as React from "react";

const QuickbooksLogo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Quickbooks--Streamline-Simple-Icons"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <desc>Quickbooks Streamline Icon: https://streamlinehq.com</desc>
    <path fill="#28a116" d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0m.642 4.134c.955 0 1.73.775 1.73 1.733v9.066h1.6a2.934 2.934 0 0 0 0-5.866h-.666V7.333h.665A4.663 4.663 0 0 1 20.63 12a4.66 4.66 0 0 1-4.658 4.667h-3.329zM7.984 7.333h3.329v12.533c-.956 0-1.73-.776-1.73-1.733V9.066h-1.6a2.934 2.934 0 0 0 0 5.867h.666v1.733h-.665A4.66 4.66 0 0 1 3.326 12a4.66 4.66 0 0 1 4.658-4.667"></path>
  </svg>
);

export default QuickbooksLogo;